exports = module.exports = require("../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".BPACSV {\n  border-bottom: 2px solid black;\n  padding: 20px;\n}\n@media print {\n  .BPACSV {\n    display: none;\n  }\n}\n.BPACSV .download {\n  background-color: #006BE9;\n  padding: 10px;\n  color: white;\n  font-weight: bold;\n  font-size: 28px;\n  border-radius: 10px;\n  width: -moz-fit-content;\n  width: fit-content;\n}", ""]);

